import React, { useState, useEffect, useMemo } from 'react'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import PeriodForm from './PeriodForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { StatusPill, ActionIconButton, ListPageShell, SideDrawer, EmptyState } from '../../Components/Ui'

const Period = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.period.get_period().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.period.period_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
            setReload(true)
        })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idPeriod) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idPeriod } = $this.dataset

        Controllers.period.get_period_id({ p_id_period: idPeriod }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idPeriod}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
        .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleOpenCreate = () => {
        setModalTitle(`Registrar ${nameSingle}`)
        setDataUpdated({})
        setModalShow(true)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.period.period_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setReload(true)
            setLoadSubmitDelete(false)
        })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idPeriod, namePeriod } = e.currentTarget.dataset
        setDataDeleted({
            p_id_period: idPeriod,
            p_name_period: namePeriod
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_period', text: 'ID', align: 'center' },
                { name: 'name_period', text: 'Descripción' },
                { name: 'state_period', text: 'Estado', align: 'center', render: r => <StatusPill tone={parseInt(r.state_period) === 1 ? 'success' : 'danger'}>
                    {parseInt(r.state_period) === 1 ? 'Activo' : 'Inactivo'}
                </StatusPill> },
                { name: 'actions', text: 'Acciones', align: 'center', render: u => {
                    return <div className="sp-row-actions">
                        <ActionIconButton tone="ghost" icon="fa fa-pen" label="Editar" data-id-period={u.id_period} onClick={handleGet} />
                        <ActionIconButton tone="danger" icon="fa fa-trash" label="Eliminar" data-id-period={u.id_period} data-name-period={u.name_period} onClick={handleShowModalDelete} />
                    </div>
                } },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && rows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={`Listado de ${namePlural}`}
            subtitle="Consulta y administra los periodos activos del sistema."
            badge="Actividad actualizada"
            primaryAction={
                <ListPageShell.PrimaryButton onClick={handleOpenCreate} icon="fa fa-plus">
                    Registrar {nameSingle}
                </ListPageShell.PrimaryButton>
            }
            onSearch={applySearch}
            filters={[
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Periodo…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-calendar"
                    title={`No hay ${namePlural.toLowerCase()} para mostrar`}
                    text="Ajusta la búsqueda o registra un nuevo periodo para empezar."
                    action={
                        <ListPageShell.PrimaryButton onClick={handleOpenCreate}>
                            Registrar {nameSingle}
                        </ListPageShell.PrimaryButton>
                    }
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>

        <SideDrawer
            open={modalShow}
            onClose={handleHideModalForm}
            title={modalTitle}
            subtitle="Los cambios se guardan al confirmar el formulario."
        >
            <PeriodForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
        </SideDrawer>

        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_period} - {dataDeleted.p_name_period}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default Period
